import styled from 'styled-components'
import {customMedia} from './common'
import {COLOR} from "src/service/constant/color";

const LayoutWrap = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  width: 100%;
  margin: 0 auto;
  padding: 60px 20px 100px;

  p {
    padding: 0;
    margin: 0;
  }

  ul {
    padding: 0;
    margin: 0;

    li {
      list-style: none;
    }
  }
`
const LayoutSubPage = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  word-break: break-all;
  overflow-wrap: break-word;

`
const SubScriptWrap = styled.div`
  display: block;
  ${customMedia.lessThan('tablet')`
    margin: 0 auto;
    max-width: 600px;
    width:100%;
  `}
`
const SubScriptTitle = styled.div`
  display: flex;
  flex-flow: column;
  gap: 6px;
  text-align: center;

  h1 {
    margin: 0;
    font-family: NotoSansRegular, sans-serif;
    font-size: 28px;
    line-height: 1.4;
    color: ${COLOR.black};
    ${customMedia.lessThan('tablet')`
      font-size: 22px;
  `}
  }

  p {
    font-family: NotoSansRegular, sans-serif;
    font-size: 16px;
    line-height: 1.4;
    margin: 0;
    color: ${COLOR.gray90};
    ${customMedia.lessThan('tablet')`
      font-size: 14px;
  `}
  }

`
const SubScriptDesc = styled.div`
  margin-top: 50px;
  word-break: break-all;
  overflow-wrap: break-word;
  font-family: NotoSansRegular, sans-serif;
  font-size: 14px;
  line-height: 1.5;

  div {
    margin-top: 26px;
  }

  p {
    margin-top: 4px;
  }

  ul {
    padding-left: 10px;
    margin-top: 4px;
    display: flex;
    flex-flow: column;
    gap: 4px;
  }

  table {
    margin-top: 10px;
  }

  ${customMedia.lessThan('tablet')`
    width: 100%;
    >p{
     font-size: 12px;   
    }
  `}

  ${customMedia.lessThan('mobile')`
    margin: 0 0 26px 0;
  `}
`

const NotFoundPageWrap = styled.div`
  width: 100%;
  margin:0 auto;
`
const NotFoundPageInner = styled.div`
  width: 100%;
  max-width: 600px;
  padding: 60px 20px 150px;
  text-align: center;
  margin:0 auto;
  p{
    font-family: NotoSansRegular, sans-serif;
    font-size: 14px;
  }
`

export {LayoutWrap, LayoutSubPage, SubScriptTitle, SubScriptDesc, SubScriptWrap, NotFoundPageWrap, NotFoundPageInner}
